import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TicketsViewComponent } from './tickets-view/tickets-view.component';
import { TicketsListComponent } from './tickets-list/tickets-list.component';

const routes: Routes = [
  {
    path:'',
    children:[
      { path:'' , redirectTo:'tickets' , pathMatch:'full'},
      {
        path:'tickets-view',component:TicketsViewComponent,
        data: {
          title: 'Tickets Stage'
        }
      },
      {
        path:'tickets-list',component:TicketsListComponent,
        data: {
          title: 'Tickets List'
        }
      },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TicketsRoutingModule { }
